export default "__VITE_ASSET__DUxn2Y4$__"